//import angular from 'angular';
import AdminUrls from '../adminUrls';


    angular.module('app.admin')
        .controller('componentOwnerSearchCtrl', [
            '$scope', 'componentOwnerSvc', 'adminUrls', 'amtXlatSvc', 'ocSecuritySvc',
            function (
                $scope, componentOwnerSvc, adminUrls: AdminUrls, amtXlatSvc, ocSecuritySvc
            ) {
                var vm = this;

                vm.status = "loading";
                vm.gridControl = {};
                vm.selectedItem = null;
                vm.selectAll = true;
                vm.showClients = false;
                vm.showSites = false;

                vm.svc = componentOwnerSvc;

                vm.adminUrls = adminUrls;

                vm.results = [];

                vm.criteria = {
                    filterValues: {
                        clientIds: [],
                        siteIds: [],
                        componentOwnerName: null,
                        active: false,
                        defaultToAllSitesWhenNoSystemHierarchyFilter: true
                    }
                };

                vm.setHeaderHeight = function (height, offset) {
                    vm.gridTop = height + offset;
                };

                vm.onSearchComplete = function () {
                    vm.selectedItem = null;
                };

                vm.selectItem = function (items) {
                    if (items != null && items.length === 1) {
                        vm.selectedItem = items[0];
                    } else {
                        vm.selectedItem = null;
                    }
                };

                vm.export = function () {
                    componentOwnerSvc.export(vm.criteria);
                };

                vm.getSearchDefaultsSuccessHandler = function (result) {
                    vm.defaultClients = result.clients;
                    vm.defaultSites = result.sites;

                    vm.defaults = {
                        activeOptions: [vm.svc.activeStates[0]]
                    };

                    vm.siteId = result.sites[0].key;

                    vm.status = "ready";

                    // focus on name field by default
                    vm.focusComponentOwnerName = true;
                };

                vm.rowParseFunction = function (response) {
                    var equipments = response.result;

                    for (var r = 0; r < equipments.length; r++) {
                        try {
                            equipments[r].accessType = ocSecuritySvc.getAccessType("Security.Settings.ComponentOwner", equipments[r].clientId, equipments[r].siteId);
                        } catch {
                            equipments[r].accessType = ocSecuritySvc.accessTypes.hide;
                        }
                    }

                    return response;
                };

                vm.getSearchDefaultsErrorHandler = function (error) {
                    vm.defaultErrors = error;
                    vm.status = "error";
                };

                vm.loadDefaults = function () {
                    vm.status = 'loading';

                    var defaultCriteria = {};

                    componentOwnerSvc.getSearchDefaultsAsync(defaultCriteria)
                        .then(vm.getSearchDefaultsSuccessHandler, vm.getSearchDefaultsErrorHandler);
                };

                function init() {
                    vm.loadDefaults();
                }

                vm.refreshGrid = function () {
                    vm.gridControl.refresh();
                };

                vm.searchSucessHandler = function (result) {
                    vm.results = result;
                };

                vm.searchErrorHandler = function (error) {
                    vm.results = null;
                };

                vm.filter = function () {
                    vm.selectedItem = undefined;
                    vm.showClients = vm.criteria.filterValues.clientIds.length !== 1;
                    vm.showSites = vm.criteria.filterValues.siteIds.length !== 1;

                    vm.refreshGrid();
                };

                vm.create = function () {
                    componentOwnerSvc.create(vm.refreshGrid);
                };

                vm.openItem = function (item) {
                    componentOwnerSvc.openItem(
                        item,
                        vm.refreshGrid,
                        amtXlatSvc.xlat(item.accessType === 2 ? 'componentOwner.edit' : 'componentOwner.view', item.name)
                    );
                };

                $scope.openItem = vm.openItem;

                $scope.$on('filterSearch', function () {
                    vm.filter();
                });

                init();
            }
        ]);
